import { useState } from 'react'
import IntegrationsTab from './IntegrationsTab'
import MapTab from './MapTab'
import StateBlock from './StateBlock'
import SyncChip from './SyncChip'
import UnitsTab from './UnitsTab'
import { errorDetail, errorMessage } from '../lib/api'
import { usePark } from '../lib/hooks'

type Tab = 'kaart' | 'plaatsen' | 'koppelingen'

const TABS: { id: Tab; label: string }[] = [
  { id: 'kaart', label: 'Kaart' },
  { id: 'plaatsen', label: 'Plaatsen' },
  { id: 'koppelingen', label: 'Koppelingen' },
]

export default function ParkDetailView({ slug }: { slug: string }) {
  const [tab, setTab] = useState<Tab>('kaart')
  const park = usePark(slug)

  if (park.isPending) return <StateBlock kind="loading" message="Park laden…" />
  if (park.isError || !park.data) {
    return (
      <StateBlock
        kind="error"
        message={errorMessage(park.error)}
        detail={errorDetail(park.error)}
        onRetry={() => void park.refetch()}
      />
    )
  }

  const detail = park.data

  return (
    <>
      <div className="main-head">
        <div>
          <h1>{detail.park.name}</h1>
          <p className="muted small">
            {detail.park.slug} · {detail.units.length} plaatsen · {detail.zones.length} velden · {detail.pois.length}{' '}
            voorzieningen
          </p>
        </div>
        <div className="spacer" style={{ flex: 1 }} />
        <span className="chips">
          {detail.integrations.map((integration) => (
            <SyncChip key={integration.id} integration={integration} />
          ))}
        </span>
      </div>

      <nav className="tabs" aria-label="Onderdelen van dit park">
        {TABS.map((item) => (
          <button
            key={item.id}
            type="button"
            aria-current={tab === item.id ? 'page' : undefined}
            onClick={() => setTab(item.id)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      {tab === 'kaart' && <MapTab slug={slug} detail={detail} />}
      {tab === 'plaatsen' && <UnitsTab slug={slug} detail={detail} />}
      {tab === 'koppelingen' && <IntegrationsTab slug={slug} detail={detail} />}
    </>
  )
}
